import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// delon
import { AlainThemeModule } from '@delon/theme';
import { DelonABCModule } from '@delon/abc';
import { DelonACLModule } from '@delon/acl';
import { DelonFormModule } from '@delon/form';
import { DelonChartModule } from '@delon/chart';
// i18n
import { TranslateModule } from '@ngx-translate/core';
// #region third libs
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { CountdownModule } from 'ngx-countdown';
import { SelectAssemblyComponent } from './assembly/select-assembly/select-assembly.component';
import { TableAssemblyComponent } from './assembly/table-assembly/table-assembly.component';
import { ShiftDaysPipe } from '../routes/teacher/jxap/shift-days.pipe';
import { ShrAssemblyComponent } from './assembly/shr-assembly/shr-assembly.component';
import { ShStatusPipe } from './pipes/shStatus';
import { JjztStatusPipe } from './pipes/jjztStatus';
import { YdztStatusPipe } from './pipes/ydztStatus';
import { ShztStatusPipe } from './pipes/shztStatus';
import { ApprovalStatusPipe } from './pipes/approvalStatus';
import { SafePipe } from './pipes/safe.pipe';
import { ClassUnitPipe } from './pipes/classUnit.pipe';
import { EnableStatusPipe } from './pipes/enableStatus';
import { TeacherTableAssemblyComponent } from './assembly/teacher-table-assembly/teacher-table-assembly.component';
import { WdpjComponent } from '../routes/student/wspj/wdpj/wdpj.component';
import {
    MatButtonModule,
    MatCard,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatSidenavModule
} from "@angular/material";
import { AngularSplitModule } from 'angular-split';

const THIRDMODULES = [NgZorroAntdModule, CountdownModule];

// #region your componets & directives
const COMPONENTS = [];
const DIRECTIVES = [];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        AlainThemeModule.forChild(),
        AngularSplitModule.forRoot(),
        DelonABCModule,
        DelonACLModule,
        DelonFormModule,
        DelonChartModule,
        // third libs
        ...THIRDMODULES,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule
    ],
    declarations: [
        // your components
        ...COMPONENTS,
        ...DIRECTIVES,
        SelectAssemblyComponent,
        TableAssemblyComponent,
        ShiftDaysPipe,
        ShrAssemblyComponent,
        ShStatusPipe,
        JjztStatusPipe,
        YdztStatusPipe,
        ShztStatusPipe,
        ApprovalStatusPipe,
        SafePipe,
        ClassUnitPipe,
        EnableStatusPipe,
        TeacherTableAssemblyComponent,
        WdpjComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        AlainThemeModule,
        DelonABCModule,
        DelonACLModule,
        DelonFormModule,
        DelonChartModule,
        // i18n
        TranslateModule,
        // third libs
        ...THIRDMODULES,
        // your components
        ...COMPONENTS,
        ...DIRECTIVES,
        // 公共组件
        SelectAssemblyComponent,
        TableAssemblyComponent,
        TeacherTableAssemblyComponent,
        ShiftDaysPipe,
        ShrAssemblyComponent,
        ShStatusPipe,
        JjztStatusPipe,
        YdztStatusPipe,
        ShztStatusPipe,
        ApprovalStatusPipe,
        SafePipe,
        ClassUnitPipe,
        EnableStatusPipe,
        MatSidenavModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule
    ],
})
export class SharedModule {
}
